
import $ from "jquery";
import {show404} from "../../scripts/_404.js";

export default function(){
    
    
    $("#maincontent").append(`
    
        <div class="container">
            <div class="row adjust-conent-center">
                <div class="col-6">
                    <div id="conversation"></div>
                    
                </div>
            </div>
        </div>
    
    `);
    
    
//     window.queue = ["Hei, jeg heter Kommune-Kari! Jeg skal hjelpe deg med å finne frem på den nye nettsiden vår.",
// "Still meg gjerne et spørsmål, eller gi meg et stikkord, så lover jeg å svare deg så godt jeg kan.",
// "Hva lurer du på?",];
    
//     const setWait = () => {
//         $("#conversation").append("<div class='wait'>...</div>");
//     }
//     const deleteWait = () => {
//         $(".wait").remove();
//     }
    
//     let showMessage = (metime = 0) => {
        
//         let time = 750;
//         if(queue[0]){
//             if(queue[0].length < 30){
//                 time = 600;
//             }
//             if(queue[0].length > 60){
//                 time = 1800;
//             }
//         setWait();
//     }
        
//         // console.log("tid",time, queue[0].length)
        
//         setTimeout(() => {
            
            
//             deleteWait();
            
//             if(queue.length > 0){
                
//                 $("#conversation").append(`
//                     <p>${queue[0]}</p>
//                 `);
//                 queue.shift();
//             }
//             showMessage(time);
            
//         }, metime);
        
//     }
    
    
    // showMessage();
    
    // $("#load").click(function(){
    //     queue.push("Dette er en test","Hvor mange meldinger blir det bra å pushe på en gang","Det er korte setninger","Det kan være lange setninger som f.eks. denne her.", "spørsmålet blir gjerne hvor lange setninger kan man vise før det hele faller i grus liksom. Før det blir usakelig å lese på en ramse.", "Var det for langt?");
    // })

    return show404();
    
} 